import {
  Outlet,
  createRootRoute,
  HeadContent,
  Scripts,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import resetCss from "~/css/reset.css?inline";
import globalCss from "~/css/globals.css?inline";

import { Footer, Header } from "~/components";

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "Blog About Coffee" },
      { description: "A collection of coffee checkins from around the world" },
      { name: "theme-color", content: "#f4a261" },
    ],
    links: [
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css?family=Raleway:300,500&display=swap",
      },
      {
        rel: "icon",
        type: "image/png",
        href: "/favicon-16x16.png",
        sizes: "16x16",
      },
      {
        rel: "icon",
        type: "image/png",
        href: "/favicon-32x32.png",
        sizes: "32x32",
      },
      { rel: "icon", type: "image/icon", href: "/favicon.ico" },
      { rel: "shortcut icon", href: "/favicon.ico" },
      {
        rel: "apple-touch-icon",
        href: "/apple-touch-icon.png",
        sizes: "180x180",
      },
      { rel: "manifest", href: "/site.webmanifest" },
    ],
  }),
  component: Component,
});

function Component() {
  return (
    <html>
      <head>
        <HeadContent />
        <style dangerouslySetInnerHTML={{ __html: resetCss }} />
        <style dangerouslySetInnerHTML={{ __html: globalCss }} />
      </head>
      <body>
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
        <Scripts />
        <TanStackRouterDevtools />
      </body>
    </html>
  );
}
